// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendedHpLandlord
// ====================================================

export interface RecommendedHpLandlord_recommendedHpLandlord {
  /**
   * The name of the receipient at the address.
   */
  name: string;
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The two-letter state or territory for the address, e.g. "NY".
   */
  state: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
}

export interface RecommendedHpLandlord_recommendedHpManagementCompany {
  /**
   * The name of the receipient at the address.
   */
  name: string;
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The two-letter state or territory for the address, e.g. "NY".
   */
  state: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
}

export interface RecommendedHpLandlord {
  /**
   * The recommended landlord address for HP Action for the currently logged-in user, if any.
   */
  recommendedHpLandlord: RecommendedHpLandlord_recommendedHpLandlord | null;
  /**
   * The recommended management company address for HP Action for the currently logged-in user, if any.
   */
  recommendedHpManagementCompany: RecommendedHpLandlord_recommendedHpManagementCompany | null;
}


export const RecommendedHpLandlord = {
  // The following query was taken from RecommendedHpLandlord.graphql.
  graphQL: `query RecommendedHpLandlord {
    recommendedHpLandlord {
        name,
        primaryLine,
        city,
        state,
        zipCode
    }
    recommendedHpManagementCompany {
        name,
        primaryLine,
        city,
        state,
        zipCode
    }
}`,
  name: "RecommendedHpLandlord",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, ): Promise<RecommendedHpLandlord> {
    return fetchGraphQL(RecommendedHpLandlord.graphQL);
  },

};

export const fetchRecommendedHpLandlord = RecommendedHpLandlord.fetch;